import { COMMERCE_API_URL } from '@vue/common/constants/config'
import axios from 'axios'
import store from '@vue/store';

axios.defaults.withCredentials = true
axios.defaults.headers.common['Content-type'] = 'application/json'

const instance = axios.create({
  baseURL: COMMERCE_API_URL
});

const onFulfilled = (response) => {
  return Promise.resolve(response);
}

const onRejected = (error) => {
  if (error.response?.status === 401 || error.response?.status === 403) {
    store.dispatch('session/clearToken');
  }

  return Promise.reject(error);
};

instance.interceptors.response.use(onFulfilled, onRejected);

export default instance;